import styled from 'styled-components';

export const UIContainer = styled.div`
  padding: 0 var(--grid-margin-space);
`;
